import { render, staticRenderFns } from "./repository.vue?vue&type=template&id=d3552b86&"
import script from "./repository.vue?vue&type=script&lang=js&"
export * from "./repository.vue?vue&type=script&lang=js&"
import style0 from "./repository.vue?vue&type=style&index=0&id=d3552b86&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports